// BlockScape theme: schodkowy horyzont, galeria, wybór pakietu (wariantu), suwak przed/po.

// horyzont z bloków: równe kolumny o losowej, ale stałej wysokości
(() => {
  let seed = 11;
  const rnd = () => ((seed = (seed * 16807) % 2147483647) / 2147483647);
  document.querySelectorAll('.skyline').forEach((el) => {
    const cols = 48, pts = ['0% 100%'];
    for (let i = 0; i < cols; i++) {
      const h = 100 - [0, 25, 25, 50, 50, 75, 100][Math.floor(rnd() * 7)];
      pts.push(`${(i / cols) * 100}% ${h}%`, `${((i + 1) / cols) * 100}% ${h}%`);
    }
    pts.push('100% 100%');
    el.style.clipPath = `polygon(${pts.join(',')})`;
  });
})();

// galeria produktu
const mainImg = document.getElementById('main-img');
document.querySelectorAll('#thumbs button').forEach((b) => b.addEventListener('click', () => {
  document.querySelectorAll('#thumbs button').forEach((x) => x.classList.remove('on'));
  b.classList.add('on');
  if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = b.dataset.src; }
}));

// pakiety = warianty produktu: podmiana id wariantu, ceny i sticky ATC
const $ = (id) => document.getElementById(id);
document.querySelectorAll('#bundles .bundle').forEach((b) => b.addEventListener('click', () => {
  document.querySelectorAll('#bundles .bundle').forEach((x) => x.classList.remove('on'));
  b.classList.add('on');
  $('variant-id').value = b.dataset.id;
  $('price').textContent = b.dataset.price;
  $('compare').textContent = b.dataset.compare;
  $('save').textContent = b.dataset.save;
  $('save').hidden = !b.dataset.save;
  if ($('sticky-price')) $('sticky-price').textContent = b.dataset.price;
  if ($('sticky-name')) $('sticky-name').textContent = b.dataset.name;
}));

// przed/po
const ba = document.getElementById('ba');
if (ba) {
  const before = ba.querySelector('.ba-before'), handle = ba.querySelector('.ba-handle');
  const move = (x) => {
    const r = ba.getBoundingClientRect();
    const p = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
    before.style.clipPath = `inset(0 ${100 - p}% 0 0)`; handle.style.left = `${p}%`;
  };
  let drag = false;
  ba.addEventListener('pointerdown', (e) => { drag = true; ba.setPointerCapture(e.pointerId); move(e.clientX); });
  ba.addEventListener('pointermove', (e) => drag && move(e.clientX));
  ba.addEventListener('pointerup', () => (drag = false));
}
